import React, { useEffect, useRef } from 'react';

const LinkedInStep = ({ data, updateData, onNext, onPrevious, isValid, isFirstStep }) => {
  const inputRef = useRef(null);

  // Focus input when component mounts
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValid) {
      onNext();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && isValid) {
      onNext();
    }
  };

  return (
    <div className="space-y-8 md:space-y-12">
      <form onSubmit={handleSubmit} className="space-y-8 md:space-y-12">
        {/* Question */}
        <div className="text-center space-y-4">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white leading-tight">
            What's your LinkedIn profile?
          </h1>
          <p className="text-lg md:text-xl text-gray-600 dark:text-gray-400">
            Let's connect your professional profile
          </p>
        </div>

        {/* Enhanced Input with Animations */}
        <div className="space-y-6">
          <div className="relative overflow-hidden pb-1">
            <input
              ref={inputRef}
              type="url"
              value={data.linkedinUrl}
              onChange={(e) => updateData('linkedinUrl', e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="https://www.linkedin.com/in/your-profile"
              className="w-full px-6 py-4 text-xl bg-transparent border-0 border-b-2 border-gray-300 dark:border-gray-600 
                       focus:outline-none focus:border-purple-500 dark:focus:border-purple-400
                       dark:text-white dark:placeholder-gray-500 placeholder-gray-400
                       transition-all duration-300 ease-in-out
                       hover:border-purple-300 dark:hover:border-purple-500
                       focus:scale-105 focus:shadow-lg focus:shadow-purple-500/10"
              required
            />
            {/* Animated underline */}
            <div className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-purple-500 to-indigo-500 transition-all duration-300 ${
              data.linkedinUrl ? 'w-full opacity-100' : 'w-0 opacity-0'
            }`}></div>
          </div>
          
          {/* Enhanced Helper Text */}
          <p className="text-base text-gray-500 dark:text-gray-400 text-center transition-all duration-300">
            Don't know your URL?{' '}
            <a 
              href="https://www.linkedin.com/in/edit/contact-info/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-purple-600 hover:text-purple-700 dark:text-purple-400 
                       dark:hover:text-purple-300 underline transition-all duration-300
                       hover:scale-105 inline-block transform"
            >
              Find it here
            </a>
          </p>
        </div>

        {/* Enhanced Navigation Buttons */}
        <div className="flex justify-between items-center border-none !border-0">
          {!isFirstStep && (
            <button
              type="button"
              onClick={onPrevious}
              className="px-6 py-3 rounded-lg text-lg font-medium text-gray-600 dark:text-gray-400 
                       hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-100 
                       dark:hover:bg-gray-700 transition-all duration-300 ease-in-out
                       transform hover:scale-105 active:scale-95 focus:ring-4 focus:ring-gray-500/20"
            >
              Back
            </button>
          )}
          
          <button
            type="submit"
            disabled={!isValid}
            className={`px-8 py-4 rounded-lg text-lg font-medium transition-all duration-300 ease-in-out transform ${
              isValid
                ? 'bg-purple-600 hover:bg-purple-700 text-white shadow-lg hover:shadow-xl hover:shadow-purple-500/25 hover:scale-105 active:scale-95 focus:ring-4 focus:ring-purple-500/20'
                : 'bg-gray-300 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed opacity-60'
            } ${isFirstStep ? 'ml-auto' : ''}`}
          >
            <span className="flex items-center">
              Continue
              <span className={`ml-2 transition-transform duration-300 ${isValid ? 'translate-x-0' : '-translate-x-1'}`}>
                →
              </span>
            </span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default LinkedInStep; 